import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "accented-container" }
const _hoisted_2 = { class: "alert-header d-flex justify-content-start align-items-center" }
const _hoisted_3 = { class: "pr-3" }
const _hoisted_4 = { class: "flex-grow-1 font-weight-bold" }
const _hoisted_5 = { class: "alert-content" }
const _hoisted_6 = { "data-testid": "notification-alert-message" }

import { computed } from 'vue';
import useStickyAlerts from '@/modules/alerts/composables/useStickyAlerts';
import { NotificationStickyAlertPropsSchema } from '@/modules/alerts/models/notification-sticky-alert-props';
import { STICKY_ALERT_TYPE } from '@/modules/alerts/models/sticky-alert-type';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';


export default /*@__PURE__*/_defineComponent({
  __name: 'WCNotificationStickyAlert',
  props: {
    type: {},
    title: {},
    options: {},
    id: {}
  },
  setup(__props: any) {

const { findAlert, answerAlert, setupTimeout } = useStickyAlerts();

const props = __props;

const alert = findAlert(STICKY_ALERT_TYPE.NOTIFICATION, props.id);

const messageSegments = computed(() => {
  const subMessage = props.options?.body;
  const orderId = props.options?.orderId;
  const hasLink = !!props.options?.link;

  if (!hasLink) {
    return [{ text: subMessage, applyLinkStyle: false }];
  }

  if (orderId && subMessage.includes(orderId)) {
    const parts = subMessage.split(orderId);
    const segments: Array<{ text: string; applyLinkStyle: boolean }> = [];

    parts.forEach((part, index) => {
      if (part) segments.push({ text: part, applyLinkStyle: false });
      if (index < parts.length - 1) segments.push({ text: orderId, applyLinkStyle: true });
    });

    return segments;
  }

  return [{ text: subMessage, applyLinkStyle: true }];
});

const close = () => {
  answerAlert(alert, { result: 'DISMISS' });
};

const handleClick = () => {
  const link = props?.options?.link;

  if (link) {
    close();
    window.location.href = link;
  }
};

setupTimeout(STICKY_ALERT_TYPE.NOTIFICATION, props.id, alert, props.options?.timeoutMs);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("div", {
      class: "accent",
      "data-testid": "notification-alert-accent"
    }, null, -1)),
    _cache[6] || (_cache[6] = _createTextVNode()),
    _createElementVNode("div", {
      class: _normalizeClass(["basic-alert", { clickable: props.options?.link }]),
      onClick: handleClick
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(FontAwesomeIcon), {
            icon: ['fas', 'bell-ring'],
            size: "lg",
            "data-testid": "notification-alert-bell-icon"
          })
        ]),
        _cache[0] || (_cache[0] = _createTextVNode()),
        _createElementVNode("div", _hoisted_4, _toDisplayString(props.title), 1),
        _cache[1] || (_cache[1] = _createTextVNode()),
        _createElementVNode("div", {
          class: "cursor-pointer pr-1",
          onClick: _withModifiers(close, ["stop"]),
          "data-testid": "notification-alert-close-button"
        }, [
          _createVNode(_unref(FontAwesomeIcon), {
            icon: "xmark",
            size: "lg",
            class: "close-icon"
          })
        ])
      ]),
      _cache[2] || (_cache[2] = _createTextVNode()),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "separator" }, null, -1)),
      _cache[4] || (_cache[4] = _createTextVNode()),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messageSegments.value, (segment, index) => {
            return (_openBlock(), _createElementBlock("span", {
              key: index,
              class: _normalizeClass({ 'link-text': segment.applyLinkStyle })
            }, _toDisplayString(segment.text), 3))
          }), 128))
        ])
      ])
    ], 2)
  ]))
}
}

})